let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("5uoHm"), load("1F2CM")]).then(() => parcelRequire('hWg6N'));